/* WC – Product new-tab broken state auto-fix (v2)
   Goal:
   - Fix the bug where, on a new tab, the product page loads with:
     * first real variant selected (e.g. "12\""),
     * Add to Cart button text = "Unavailable",
     * button disabled,
     even though a manual reload fixes everything.

   Strategy:
   - Run once on product pages.
   - Inspect the main product form, variant <select> and ATC button.
   - If we detect the "broken new-tab" combination, reload the page ONCE.
   - Use sessionStorage flag per path to avoid infinite loops.
*/

(function () {
  'use strict';

  // Only run on product template
  if (!document.body || !document.body.classList.contains('template-product')) {
    return;
  }

  // ---- Helpers ----
  function getForm() {
    return (
      document.querySelector('.product-form form[action*="/cart/add"]') ||
      document.querySelector('form.product-form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getSelect(form) {
    if (!form) return null;
    return (
      form.querySelector('[data-variant-select]') ||
      form.querySelector('.product-form__input select') ||
      form.querySelector('select[name="id"]') ||
      form.querySelector('select')
    );
  }

  function getButton(form) {
    if (!form) return null;
    return (
      form.querySelector('button[name="add"]') ||
      form.querySelector('.product-form__cart-submit') ||
      form.querySelector('.product-form__submit')
    );
  }

  function isPlaceholderOption(textLower, value) {
    if (!textLower) textLower = '';
    if (!value) value = '';

    return (
      /please select|select size|no option selected|válassz|valassz/.test(textLower) ||
      value.trim() === '' ||
      value.trim().toLowerCase() === 'default' ||
      value.trim().toLowerCase() === 'placeholder'
    );
  }

  function needsReload() {
    const form = getForm();
    if (!form) return false;

    const select = getSelect(form);
    const btn    = getButton(form);

    if (!select || !btn || !select.options || !select.options.length) {
      // Nothing to analyse
      return false;
    }

    const btnText = (btn.textContent || '').trim().toLowerCase();

    // If the button does NOT say "Unavailable", we are fine.
    if (btnText !== 'unavailable') return false;

    // Current or first option
    const idx = typeof select.selectedIndex === 'number' && select.selectedIndex >= 0
      ? select.selectedIndex
      : 0;

    const opt = select.options[idx];
    const optText  = (opt && opt.textContent) ? opt.textContent.trim() : '';
    const optValue = (opt && opt.value) ? opt.value.trim() : '';
    const optLower = optText.toLowerCase();

    // Two bug-minták:
    // 1) Placeholder + "Unavailable" (régi eset)
    const looksLikePlaceholder = isPlaceholderOption(optLower, optValue);

    // 2) Első igazi méret (pl. "12\"") kiválasztva + "Unavailable" + disabled
    const looksLikeRealSize = !looksLikePlaceholder && optText.length > 0;

    const btnDisabled = btn.disabled === true || btn.getAttribute('aria-disabled') === 'true';

    // "Broken new-tab" = gomb "Unavailable", disabled,
    // és a select NEM placeholder (vagyis a theme rossz state-ben állt meg).
    if (btnDisabled && (looksLikePlaceholder || looksLikeRealSize)) {
      return true;
    }

    return false;
  }

  function runGuard() {
    try {
      const key = '__wc_product_reload_' + window.location.pathname;

      if (!needsReload()) {
        // Page looks fine → clear any old flag and exit
        try { sessionStorage.removeItem(key); } catch (e) {}
        return;
      }

      // Broken state detected.
      // Reload ONCE per path in this tab.
      const already = (function () {
        try { return !!sessionStorage.getItem(key); }
        catch (e) { return false; }
      })();

      if (!already) {
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        // console.log('[WC] product new-tab bug detected → reloading once');
        window.location.reload();
      } else {
        // We already reloaded once, don't loop any further.
        try { sessionStorage.removeItem(key); } catch (e) {}
      }
    } catch (err) {
      // Fail-safe: never break the page if something goes wrong here
      console.warn('[WC] product auto-reload guard error', err);
    }
  }

  function init() {
    // Small delay so the theme's own JS has time to run first.
    setTimeout(runGuard, 200);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
